import styled from 'styled-components';

const FeaturedContentContainer = styled.div`
  display: block;
  justify-content: center;

  .in-page-features-v5--featured-content-img {
    max-height: 275px;
    margin-bottom: 30px;
    display: inline-flex;
    align-items: flex-end;

    img {
      height: auto;
      max-width: 100%;
      width: auto;
      object-fit: contain;
    }
  }

  h2,
  p {
    color: var(--black);
    text-align: left !important;
  }

  @media (max-width: 575px) {
    width: 100%;

    h2 {
      margin-bottom: 10px;
    }

    p {
      margin-bottom: 20px;
    }
  }
`;

export { FeaturedContentContainer };
